import { useEffect } from 'react';

import { TypeButton } from '../components/reusable/button';
import { ClockSVG } from '../components/reusable/svgs';
import { useCountDown } from '../components/reusable/timer';

const InactivityAlert = ({
	stayLoggedIn,
	handleSignOut,
	startTimer,
}: {
	stayLoggedIn: () => void;
	handleSignOut: () => void;
	startTimer: boolean;
}) => {
	const countdown = useCountDown(20, startTimer);
	const isExpired = countdown === '00:00:00';

	useEffect(() => {
		if (isExpired) {
			handleSignOut();
		}
	}, [isExpired]);

	return (
		<div className='f-column-33 text-center p-4'>
			<div className='f-row-10 align-items-center justify-content-center'>
				<ClockSVG />
				<h4 className='m-0 color-danger'>Inactivity Alert</h4>
			</div>
			<p className='text-little'>
				We noticed that you have been inactive for a while. To keep your account secure, you will be automatically logged out in{' '}
				<span className='color-danger'>{countdown}</span> if no activity is detected.
			</p>
			<div className='f-row justify-content-center'>
				<TypeButton
					title='Please Click here to stay logged in'
					onClick={stayLoggedIn}
					buttonSize='small'
				/>
			</div>
		</div>
	);
};

export default InactivityAlert;
